import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../i18n/LangContext";
import { IMG } from "../../data/content";

export const ScrollReveal = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "center center"] });
  const clip = useTransform(scrollYProgress, [0, 1], ["inset(12% 18% 12% 18% round 24px)", "inset(0% 0% 0% 0% round 0px)"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.25, 1]);
  const textY = useTransform(scrollYProgress, [0, 1], ["40%", "0%"]);

  return (
    <section ref={ref} data-testid="home-scroll-reveal" className="relative h-[80vh] min-h-[480px] lg:h-screen">
      <motion.div style={{ clipPath: clip }} className="absolute inset-0 overflow-hidden bg-[#1C1917]">
        <motion.img style={{ scale }} src={IMG.europa} alt="" className="h-full w-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-[#1C1917]/30" />
      </motion.div>
      <motion.div style={{ y: textY }} className="relative flex h-full flex-col items-center justify-center px-5 text-center">
        <p className="font-serif text-5xl leading-[0.95] tracking-tight text-[#FBF9F5] sm:text-7xl lg:text-9xl">{t.reveal.a}</p>
        <p className="font-serif text-5xl italic leading-[0.95] tracking-tight text-[#E9B79F] sm:text-7xl lg:text-9xl">{t.reveal.b}</p>
      </motion.div>
    </section>
  );
};
